import request from "./httpService";

const ACTIVITY_ENDPOINT = '/activity';

const getRecentActivities = (params) => {
    return request({
        method: 'GET',
        url: `${ACTIVITY_ENDPOINT}/recent`,
        params: params
    });
};

const getCustomerActivities = (customerId, limit = 20) => {
    return request({
        method: 'GET',
        url: `${ACTIVITY_ENDPOINT}/customer/${customerId}`,
        params: { limit }
    });
};

const getDashboardActivities = (limit = 30) => {
    return request({
        method: 'GET',
        url: `${ACTIVITY_ENDPOINT}/dashboard`,
        params: { limit }
    });
};

export const ActivityService = {
    getRecentActivities,
    getCustomerActivities,
    getDashboardActivities,
};
